module.exports = __webpack_public_path__ + "img/screenshot3.d26c3a65.jpg";